"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
function NewsGridConsumer() {
  const {
    posts,
    loading,
    error,
    refetch
  } = usePosts();
  if (loading) {
    return <div data-section-id="70640" className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
        {[...Array(3)].map((_, i) => <Card key={i} data-index={i} className="h-[450px] rounded-lg border-none bg-muted/20 animate-pulse shadow-sm">
            <div className="h-48 w-full rounded-t-lg bg-muted/50" />
            <CardHeader>
              <div className="h-6 w-3/4 rounded bg-muted/50" />
              <div className="h-6 w-1/2 rounded bg-muted/50" />
            </CardHeader>
            <CardContent>
              <div className="space-y-2">
                <div className="h-4 w-full rounded bg-muted/50" />
                <div className="h-4 w-full rounded bg-muted/50" />
                <div className="h-4 w-2/3 rounded bg-muted/50" />
              </div>
            </CardContent>
          </Card>)}
      </div>;
  }
  if (error) {
    return <div className="flex flex-col items-center justify-center py-12 text-center">
        <p className="mb-4 font-sans text-muted-foreground">
          Gagal memuat daftar opini terbaru.
        </p>
        <Button onClick={refetch} variant="outline" className="rounded-full">
          Coba Lagi
        </Button>
      </div>;
  }
  if (posts.length === 0) {
    return <div className="py-12 text-center">
        <p className="font-sans text-muted-foreground">Belum ada artikel opini saat ini.</p>
      </div>;
  }
  return <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
      {posts.map((post, i) => <Card key={post.id} data-index={i} className="group flex h-full flex-col overflow-hidden rounded-lg border-none bg-card shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-md">
          <div className="relative aspect-video w-full overflow-hidden rounded-t-lg">
            <img src={post.featuredImage || "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/news_placeholder_warm.png"} alt={post.title} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
          </div>

          <CardHeader className="pb-3 pt-6">
            <CardTitle className="font-sans text-2xl font-bold leading-tight text-foreground transition-colors duration-300 group-hover:text-primary line-clamp-2 sm:line-clamp-3">
              {post.title}
            </CardTitle>
          </CardHeader>

          <CardContent className="flex-grow pb-4">
            <div className="font-sans text-sm leading-relaxed text-muted-foreground line-clamp-3" dangerouslySetInnerHTML={{
          __html: post.excerpt || ""
        }} />
          </CardContent>

          <CardFooter className="flex justify-start pb-6 pl-6 pt-0">
            <Link to={post.link || "#"}>
              <Button variant="ghost" className="h-auto rounded-none bg-transparent p-0 font-sans text-sm sm:text-base font-medium text-secondary transition-colors hover:bg-transparent hover:text-primary">
                Baca Selengkapnya — Oleh Redaksi
              </Button>
            </Link>
          </CardFooter>
        </Card>)}
    </div>;
}
export default function BeritaTerbaru() {
  const wp_query_params = {
    per_page: 3,
    order: "desc",
    orderby: "date"
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section id="daftar-artikel-opini" className="relative w-full overflow-hidden bg-background text-foreground py-20 md:py-24 lg:py-32">
      <div className="absolute -left-40 top-20 h-96 w-96 rounded-full bg-primary/5 blur-3xl" />
      <div className="absolute -right-40 bottom-20 h-96 w-96 rounded-full bg-secondary/10 blur-3xl" />

      <div className="container relative mx-auto px-4 md:px-6">
        <div className="mb-12 text-center md:mb-16">
          <h2 className="mb-4 font-sans text-4xl font-bold tracking-tight text-foreground sm:text-4xl md:text-5xl">
            Daftar Artikel Opini
          </h2>
          <p className="mx-auto max-w-2xl font-sans text-base sm:text-lg text-muted-foreground">
            Menyajikan perspektif tajam dan analisis mendalam dari berbagai tokoh mengenai isu nasional dan daerah.
          </p>
        </div>

        <PostsProvider wp_query={{
        per_page: 3,
        order: "desc",
        orderby: "date"
      }}>
          <NewsGridConsumer />
        </PostsProvider>
      </div>
    </section>;
}